import i18next from 'i18next';

import { QuestionnaireNavigationConfig } from 'app/main/questionnaire/QuestionnaireConfig';

import { AMLNavigationConfig } from 'app/main/aml/AMLConfig';
import { HomePageConfigNavigationConfig } from 'app/main/home-page/HomePageConfig';
import { DashboardNavigationConfig } from '../main/dashboard/DashboardConfig';
import { TeamsNavigationConfig } from '../main/teams/TeamsConfig';
import { ApplicationsNavigationConfig } from '../main/applications/ApplicationsConfig';
import BillingNavigationConfig from '../main/billing/billingNavigationConfig';
import { ClientDetailsNavigationConfig } from '../main/client-details/ClientDetailsConfig';
import { VerificationsNavigationConfig } from '../main/verifications/VerificationsConfig';
import { WorkflowBuilderNavigationConfig } from '../main/workflow-builder/WorkflowBuilderConfig';
import { UniversalLinksNavigationConfig } from '../main/universal-links/UniversalLinksConfig';
import { TransactionMonitoringNavigationConfig } from '../main/transaction-monitoring/TransactionMonitoringConfig';

['uk-UA', 'en-US'].forEach((lang) =>
  i18next.addResourceBundle(lang, 'navigation', require(`./navigation-i18n/${lang}`).default)
);

const navigationConfig = [
  HomePageConfigNavigationConfig,
  DashboardNavigationConfig,
  VerificationsNavigationConfig,
  ClientDetailsNavigationConfig,
  TeamsNavigationConfig,
  ApplicationsNavigationConfig,
  WorkflowBuilderNavigationConfig,
  UniversalLinksNavigationConfig,
  QuestionnaireNavigationConfig,
  AMLNavigationConfig,
  TransactionMonitoringNavigationConfig,
  BillingNavigationConfig,
  // {
  //   id: 'setting',
  //   title: 'Setting',
  //   subtitle: 'You can get settings there',
  //   translate: 'SETTING',
  //   translateSubtitle: 'SUBTITLE',
  //   type: 'group',
  //   icon: 'apps',
  //   children: [],
  //   auth: authRoles.manager,
  // },
];

export default navigationConfig;
